"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _dropdown = require("../../basic/dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _menu = require("../../basic/menu");

var _menu2 = _interopRequireDefault(_menu);

var _icon = require("../../basic/icon");

var _icon2 = _interopRequireDefault(_icon);

var _button = require("../../basic/button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Topbar = _react2["default"].createClass({
  displayName: "Topbar",
  getDefaultProps: function getDefaultProps() {
    return {
      onLogout: function onLogout() {},
      userName: "未登录用户",
      title: "电信云公司业务系统"
    };
  },
  render: function render() {
    var userDropdown = _react2["default"].createElement(
      _menu2["default"],
      null,
      _react2["default"].createElement(
        _menu2["default"].Item,
        { key: "0" },
        _react2["default"].createElement(
          "a",
          { disabled: true },
          "个人设置"
        )
      ),
      _react2["default"].createElement(
        _menu2["default"].Item,
        { key: "1" },
        _react2["default"].createElement(
          "a",
          { onClick: this.props.onLogout },
          "注销"
        )
      ),
      _react2["default"].createElement(_menu2["default"].Divider, null),
      _react2["default"].createElement(
        _menu2["default"].Item,
        { key: "3", disabled: true },
        "会员功能"
      )
    );
    return _react2["default"].createElement(
      "div",
      { className: "topbar" },
      _react2["default"].createElement(
        "div",
        { className: "topbar-logo" },
        _react2["default"].createElement(
          "h3",
          null,
          _react2["default"].createElement(
            "a",
            { href: "#" },
            this.props.title
          )
        )
      ),
      _react2["default"].createElement(
        "div",
        { className: "topbar-right" },
        _react2["default"].createElement(
          _dropdown2["default"],
          { overlay: userDropdown, style: { "float": "right" } },
          _react2["default"].createElement(
            "a",
            { className: "ant-dropdown-link", href: "#" },
            this.props.userName,
            " ",
            _react2["default"].createElement(_icon2["default"], { type: "down" })
          )
        )
      )
    );
  }
});

exports["default"] = Topbar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/frame/topbar.jsx
 ** module id = 619
 ** module chunks = 0
 **/